<template>
    <div class="general-setting-container">
        <div class="row row1">
            <div class="form-item">
                <div class="label"> <span class="required">*</span> {{ $t('FORM_LABEL_siteName') }}:</div>
                <div class="input">
                    <el-input size="mini" v-model="siteName" @change="onSiteNameChange"></el-input>
                </div>
            </div>
        </div>
        <div class="row row1">
            <div class="form-item">
                <div class="label"> <span class="required">*</span> {{ $t('FORM_LABEL_clientName') }}:</div>
                <div class="input">
                    <el-input size="mini" v-model="clientName" @change="onClientNameChange"></el-input>
                </div>
            </div>
        </div>

        <!--<div class="row2">
             {{ $t('CONFIG_FILE_LIMIT') }}
        </div>
        <div class="row row3">
            <div class="row3-left">
                <div class="form-item">
                    &lt;!&ndash; <div class="label">{{ $t('LIMIT_CYCLE') }}</div> &ndash;&gt;
                    <div class="input">
                        <el-input-number :min="0" size="mini" v-model="limits.cycle" @change="onLimitChange"></el-input-number>
                    </div>
                    <div class="label"> {{ $t('UNIT_01') }}</div>
                </div>
                <div class="form-item">
                    &lt;!&ndash; <div class="label">{{ $t('DOWNLOAD_SIZE') }}</div> &ndash;&gt;
                    <div class="input">
                        <el-input-number :min="0" size="mini" v-model="limits.fileSize"></el-input-number>
                    </div>
                    <div class="label"> MB</div>
                </div>
            </div>
            <div class="row3-middle">
                <div class="form-item">
                    <div class="label">{{ $t('OR') }}</div>
                </div>
            </div>
            <div class="row3-right">
                <div class="form-item">
                    &lt;!&ndash; <div class="label">{{ $t('LIMIT_NUM') }}</div> &ndash;&gt;
                    <div class="input">
                        <el-input-number :min="0" size="mini" v-model="limits.fileNum"></el-input-number>
                    </div>
                    <div class="label"> {{ $t('UNIT_02') }}</div>
                </div>
            </div>
        </div>-->
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import { loading } from '@/utils'

export default {
    name: 'GeneralSetting',
    data() {return {
        siteId: "",
        siteName: "",
        clientName: "",
        limits: {
            fileSize: 0,
            cycle: 0,
            fileNum: 0
        }
    }},
    mounted() {
        this.siteId = this.getSite.siteId
        this.initConf()
    },
    methods: {
        onSiteNameChange() {
            this.$emit('onConfChange', {
                tab: 0,
                key: 'siteName',
                value: this.siteName
            })
        },
        onClientNameChange() {
            this.$emit('onConfChange', {
                tab: 0,
                key: 'clientName',
                value: this.clientName
            })
        },
        onLimitChange() {
            this.$emit('onConfChange', {
                tab: 0,
                key: 'limits',
                value: this.limits
            })
        },
        handleSave() {
            return API.general.saveGeneral({
                "siteId": this.siteId,
                "siteName": this.siteName,
                "clientName": this.clientName,
                "limits": this.limits
            }).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_save_success'))
                    this.$store.state.common.siteInfo.clientName = this.clientName
                    this.$store.state.common.siteInfo.siteName = this.siteName
                } else {
                    this.$message.success(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {})
        },
        async initConf() {
            const _loading = loading()
            _loading.load()
            const { code, data } = await API.general.queryGeneral({ siteId: this.siteId })
            if (code === '1') {
                this.siteName = data.siteName
                this.clientName = data.clientName
                const limits = data.siteConfig.downloadLimit.split(',')
                this.limits = {
                    fileSize: limits[0],
                    cycle: limits[1],
                    fileNum: limits[2]
                }
            } else {
                this.$message({
                    type: 'error',
                    message: this.$t(code)
                })
            }
            _loading.close()
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        })
    }
}
</script>
<style scoped>
.general-setting-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.general-setting-container .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 10px;
}
.general-setting-container .row .form-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 30px;
}
.general-setting-container .row .form-item .label {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: 13px;
    margin-left: 5px;
    margin-right: 5px;
    font-weight: 600;
}
.general-setting-container .row .form-item .label .required {
    color: #c96c6c;
}
.general-setting-container .row1 .form-item .input{
    width: 400px;
}
.general-setting-container .row2 {
    font-size: 13px;
    font-weight: 600;
    margin-left: 10px;
    border-left: solid 3px #3879eb;
    padding-left: 5px;
    margin-top: 20px;
}
.general-setting-container .row3 {
    display: flex;
    flex-direction: row;
    height: 100px;
    margin-left: 40px;
}
.general-setting-container .row3 > div {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.general-setting-container .row3 .row3-left, .general-setting-container .row3 .row3-middle {
    justify-content: space-between;
}
.general-setting-container .row3 .row3-middle, .general-setting-container .row3 .row3-right {
    justify-content: flex-end;
}
.row3-middle .label {
    margin-bottom: 7px;
}
</style>
